import {AccountDetailDialogController} from './AccountDetailDialogController';

export const EDITROUTE = 'administration.editAccount';
export const EDITTITLE = 'EDIT_ACCOUNTS';

/** @ngInject */
export class EditAccountController extends AccountDetailDialogController {
    constructor($scope, userService, arsMainDependencies) {
        super($scope, userService, arsMainDependencies, "update");
        this.service.service.config.params['id'] = this.id;
    }
}
